module.exports = __webpack_public_path__ + "static/media/greenhouse2Step7-2.a901ef95.jpg";